import { useEffect, useState } from "react"
import { Wrapper, Header, TextsSection, HeadingColor, FrameWrapper, Frame, SignImage, Caption } from "./ReadingSignsStyle"
import { ReadingSignsData } from "./ReadingSignsData"
import { colors } from "../../../components/01_config/Colors"
import Topics from "../04_topics/Topics"
import useInstantScroll from "../../../hooks/useInstalntScroll"
import ToTheTop from "../../../components/04_common/02_tothetop/ToTheTop"
import { useSelector } from "react-redux"
import { reading } from "../../../i18n/07_reading"

const ReadingSigns = () => {
    const lang = useSelector(state => state.lang.lang)
    const t = reading[lang]

    const [isGuest, setIsGuest] = useState(false)

    const groupedByLesson = Array.from({ length: 30 }, (_, i) =>
        ReadingSignsData.filter(item => item.lesson === i + 1)
    );

    const [signData, setSignData] = useState(
        groupedByLesson)

    const { lessons } = useSelector(state => state.studentLessons)
    const { jumpToHash } = useInstantScroll();

    const role = useSelector((s) => s.auth?.user?.role); // ✅ add
    const isPrivileged = role === "TEACHER" || role === "ADMIN"; // ✅ add

    const isLessonUnlocked = (lessonNumber) => {
        // ✅ TEACHER/ADMIN: show everything
        if (isPrivileged) return true;

        if (!lessons || lessons.length === 0) {
            return lessonNumber === 0
        }
        const lesson = lessons.find((l) => l.order === lessonNumber)
        return !!lesson?.isUnlocked
    }

    const clickLesson = (lessonNumber) => {
        if (!isLessonUnlocked(lessonNumber)) return
        jumpToHash(`#lesson-${lessonNumber}`)
    }


    const showCaption = (id) => {
        setSignData(prev =>
            prev.map(lessonArr =>
                lessonArr.map(sign =>
                    sign.id === id
                        ? {
                            ...sign,
                            visibility: sign.visibility === "hidden" ? "visible" : "hidden",
                        }
                        : sign
                )
            )
        );
    };


    // const clickLesson = (index) => {

    //     jumpToHash(`#lesson-${lessonNumber}`)
    // }

    useEffect(() => {
        setIsGuest(!lessons || lessons.length === 0);
    }, [lessons]);

    return (
        <Wrapper>
            <Header>
                {t.readingSignsHeader}
            </Header>
            <Topics
                isGuest={isGuest}
                clickLesson={clickLesson}
                isLessonUnlocked={isLessonUnlocked}
            />
            {signData.map((value, index) => {

                const lessonNumber = index + 1
                if (!isLessonUnlocked(lessonNumber)) {
                    return null
                }

                return (
                    <TextsSection
                        key={index}
                        id={`lesson-${lessonNumber}`}
                    >
                        <HeadingColor
                        >
                            Lesson {lessonNumber}
                        </HeadingColor>
                        <FrameWrapper>

                            {value.map((val, ind) => (

                                <Frame key={ind}>
                                    <SignImage
                                        src={val.image}
                                        id={val.id}
                                        onClick={() => showCaption(val.id)}
                                    />
                                    <Caption style={{ visibility: val.visibility }}>{val.caption}</Caption>
                                </Frame>
                            ))}
                        </FrameWrapper>
                    </TextsSection>
                )
            })}
            <ToTheTop />
        </Wrapper>
    )
}

export default ReadingSigns
